module.exports = "<companies-list ng-if=\"companies.ready\"></companies-list>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/admin/companies/companies.html
 ** module id = 367
 ** module chunks = 0
 **/